// extracted by mini-css-extract-plugin
module.exports = {"wrap":"HomePage_wrap__1WorC","title":"HomePage_title__40ve3","subtitle":"HomePage_subtitle__7vijT"};